import React, {useEffect, useState} from 'react';
import {makeStyles} from '@mui/styles';
import {Card, Grid} from '@mui/material';
import {Redirect} from 'react-router-dom';

import {UsersMetrics, TopUserDocumentsViewedMetrics, SharedUsersMetrics} from './components';
import {useDispatch, useSelector} from 'react-redux';
import {DocumentMetrics, DocumentsHistory, LatestDocuments, StagedDocumentMetrics} from '../components';
import YourSharedUsersTable from './components/SharedUsersTable';
import {dashboardService} from '../../../store/services';
import {history} from '../../../helpers/history';
import LoadingSpinner from "../../../components/Spinner/loading.spinner";
import RecentDocumentsSharedByUser from "./components/RecentDocumentsSharedByUserMetrics";
import buildGridItem from '../../../common/buildGridItems';
import { CompanyMetrics, PendingDocuments } from '../AdminDashboard/components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const UserDashboard = () => {
  const classes = useStyles();
  const user = useSelector(state => state.authentication.user);
  const [metrics, setMetrics] = useState(null);
  const dispatch = useDispatch();

  const handleAddSharedUsers = event => {
    history.push("/sharedusers/add");
  };

  useEffect(() => {
    let isSubscribed = true;
    if (user) {
      dashboardService.getUserDashboardMetrics()
        .then(metrics =>  {
           if (isSubscribed) {
             setMetrics(metrics.data);
           } else {
             setMetrics(null);
           }
        })
    }

    return () => (isSubscribed = false);

  }, [user, dispatch]);

  return (
    <React.Fragment>
      { user.role !== null  && (user.role.includes('User'))? (<div className={classes.root}>
        <Grid
          container
          spacing={4}
        >
          {buildGridItem(metrics, (<UsersMetrics metrics={metrics}/>), 'User Metrics', {xl: 6,lg: 6,md: 6,sm: 6, xs: 12})}
          {buildGridItem(metrics, (<SharedUsersMetrics metrics={metrics}/>), 'Virtual Data Room Users', {xl: 6,lg: 6,md: 6,sm: 6, xs: 12})}
          {buildGridItem(metrics, (<DocumentMetrics metrics={metrics}/>), 'Multimedia Metrics', {xl: 4,lg: 4,md: 4,sm: 12, xs: 12})}
          {buildGridItem(metrics, (<StagedDocumentMetrics metrics={metrics}/>), 'Staged Multimedia Metrics', {xl: 4,lg: 4,md: 4,sm: 12, xs: 12})}
          {buildGridItem(metrics, (<DocumentsHistory metrics={metrics}/>), 'Multimedia History', {xl: 4,lg: 4,md: 4,sm: 12, xs: 12})}
          {buildGridItem(metrics, (<LatestDocuments metrics={metrics}/>), 'Latest Multimedia', {xl: 12,lg: 12,md: 12,sm: 12, xs: 12})}
          {buildGridItem(metrics, (<TopUserDocumentsViewedMetrics metrics={metrics}/>), 'Top Viewed Multimedia', {xl: 6,lg: 6,md: 6,sm: 12, xs: 12})}
          {buildGridItem(metrics, (<RecentDocumentsSharedByUser metrics={metrics}/>), 'Recent Documents Shared By User', {xl: 6,lg: 6,md: 6,sm: 12, xs: 12})}
          {buildGridItem(metrics, (<YourSharedUsersTable
            memberGuid={user.id}
            userName={user.userName}
            companyId={user.companyId}
            handleAddSharedUsers={handleAddSharedUsers}
          />), 'Your Virtual Data Room Users', {xl: 12,lg: 12,md: 12,sm: 12, xs: 12})}
        </Grid>
      </div>): (<Redirect to={'/login'}/>)}
    </React.Fragment>

  );
};

export default UserDashboard;
